import type { CallbackEvent } from "@shopify/polaris-types";
import type { ButtonStyle } from "@codway-dev/ui";
import {
  Divider,
  ColorRow,
  NumericField,
} from "../../../components/shared/EditorShared";

const ANIMATION_OPTIONS: { value: ButtonStyle["animation"]; label: string }[] =
  [
    { value: "none", label: "Ninguna" },
    { value: "pulse", label: "Pulso" },
    { value: "shake", label: "Vibración" },
    { value: "bounce", label: "Rebote" },
  ];

export function ButtonStyleFields({
  style,
  onChange,
}: {
  style: ButtonStyle;
  onChange: (updated: Partial<ButtonStyle>) => void;
}) {
  return (
    <s-stack direction="block" gap="base">
      <s-text-field
        label="Texto del botón"
        value={style.text}
        onInput={(e: CallbackEvent<"s-text-field">) =>
          onChange({ text: e.currentTarget.value })
        }
      />

      <div className="grid grid-cols-2 gap-3">
        <s-select
          label="Animación de botón"
          value={style.animation}
          onChange={(e: CallbackEvent<"s-select">) =>
            onChange({
              animation: e.currentTarget.value as ButtonStyle["animation"],
            })
          }
        >
          {ANIMATION_OPTIONS.map((opt) => (
            <s-option key={opt.value} value={opt.value}>
              {opt.label}
            </s-option>
          ))}
        </s-select>
      </div>

      <Divider />

      <s-grid gridTemplateColumns="1fr 1fr" gap="base">
        <ColorRow
          label="Color del fondo"
          value={style.backgroundColor}
          onChange={(v) => onChange({ backgroundColor: v })}
        />
        <ColorRow
          label="Color del texto"
          value={style.textColor}
          onChange={(v) => onChange({ textColor: v })}
        />
      </s-grid>

      <Divider />

      <s-grid gridTemplateColumns="1fr 1fr" gap="base">
        <NumericField
          label="Tamaño del texto"
          min={10}
          value={style.textSize}
          onChange={(v) => onChange({ textSize: v })}
        />
        <NumericField
          label="Radio del borde"
          min={0}
          value={style.borderRadius}
          onChange={(v) => onChange({ borderRadius: v })}
        />
      </s-grid>

      <Divider />

      <s-grid gridTemplateColumns="1fr 1fr" gap="base">
        <NumericField
          label="Ancho del borde"
          min={0}
          value={style.borderWidth}
          onChange={(v) => onChange({ borderWidth: v })}
        />
        <ColorRow
          label="Color del borde"
          value={style.borderColor}
          onChange={(v) => onChange({ borderColor: v })}
        />
      </s-grid>

      <NumericField
        label="Sombra"
        min={0}
        value={style.shadow}
        onChange={(v) => onChange({ shadow: v })}
      />
    </s-stack>
  );
}
